import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Timeline from "@/pages/Timeline";
import Game from "@/pages/Game";
import Stories from "@/pages/Stories";
import Memorial from "@/pages/Memorial";
import Quiz from "@/pages/Quiz";
import TakeAction from "@/pages/TakeAction";
import Share from "@/pages/Share";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App grain-overlay relative">
      <BrowserRouter>
        <Nav />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/timeline" element={<Timeline />} />
            <Route path="/path" element={<Game />} />
            <Route path="/stories" element={<Stories />} />
            <Route path="/memorial" element={<Memorial />} />
            <Route path="/learn" element={<Quiz />} />
            <Route path="/act" element={<TakeAction />} />
            <Route path="/share" element={<Share />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
        </main>
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
